import axios from 'axios';

const API_BASE_URL = ''; // Use relative URLs - works on any domain

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;